<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner">
        <div class="header-row">
            <h1 class="title-default">{{ isEdicao ? 'Editar' : 'Nova' }} Automação</h1>
            <p class="welcome-message">
                <button mat-icon-button type="button" (click)="cancelar()">
                    <mat-icon>arrow_back</mat-icon>
                </button>
                Aqui você consegue configurar <span class="display-name">Extrações Automáticas</span>
                de dados das funcionalidades existentes
            </p>
        </div>

        <form [formGroup]="model" class="form-content">
            <div class="action-card">
                <h3 class="section-title">
                    <mat-icon>schedule</mat-icon> Gatilho e Agendamento
                </h3>
                <div class="row">
                    <div class="col-md-6">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Nome da Automação</mat-label>
                            <input matInput formControlName="nomeAutomacao">
                            <mat-error>Campo obrigatório</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-md-6">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Perfis Destinatários</mat-label>
                            <mat-select formControlName="listIdPerfil" multiple>
                                @for(perfil of listaPerfis; track perfil.idPerfil){
                                <mat-option [value]="perfil.idPerfil">{{perfil.nome}}</mat-option>
                                }
                            </mat-select>
                            <mat-hint>Usuários com estes perfis receberão os dados.</mat-hint>
                            <span matSuffix class="material-symbols-outlined info-icon" matTooltip="Os usuários selecionados receberão os dados diretamente em seus e-mails
                                cadastrados. Certifique-se de que os endereços de e-mail estão atualizados no módulo de
                                perfis.">info
                            </span>
                            <mat-error>Selecione ao menos um perfil</mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-4">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Início dos Envios</mat-label>
                            <input matInput [matDatepicker]="picker" formControlName="datetimeInicio"
                                inputmode="numeric" maxlength="10" placeholder="DD/MM/AAAA"
                                (keydown)="onDateKeydown($event)" (input)="onDateInput($event, model.get('datetimeInicio'))">
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                            @if (model.get('datetimeInicio')?.hasError('dataInvalida') || model.get('datetimeInicio')?.hasError('matDatepickerParse')) {
                            <mat-error>Informe uma data válida no formato DD/MM/AAAA</mat-error>
                            } @else {
                            <mat-error>Campo obrigatório</mat-error>
                            }
                        </mat-form-field>
                    </div>

                    <div class="col-md-4">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Período de Fechamento</mat-label>
                            <mat-select formControlName="idTipoRecorrencia"
                                (selectionChange)="onTipoRecorrenciaChange()">
                                @for(tipo of listaTiposRecorrencia; track tipo.idTipoRecorrencia){
                                <mat-option [value]="tipo.idTipoRecorrencia">{{tipo.nomeRecorrencia}}</mat-option>
                                }
                            </mat-select>
                            <span matSuffix class="material-symbols-outlined info-icon"
                                matTooltip="Escolhe qual o período de fechamento será extraído. Se semanal será extraído o fechamento da semana anterior de segunda à domingo. Se mensal será extraído o fechamento do mês anterior do dia 1 ao último dia.
                            Você receberá os dados do fechamento do período recorrentemente no dia do recebimento escolhido" (click)="$event.stopPropagation()">info
                            </span>
                            <mat-error>Campo obrigatório</mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-md-4">
                        @if(isSemanal){
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Dia do envio dos dados</mat-label>
                            <mat-select formControlName="valorRecorrencia">
                                @for(dia of diasSemana; track dia.id){
                                <mat-option [value]="dia.id">{{dia.label}}</mat-option>
                                }
                            </mat-select>
                            <span matSuffix class="material-symbols-outlined info-icon"
                                matTooltip="Selecione o dia da semana que você quer receber os dados do fechamento da semana anterior"
                                (click)="$event.stopPropagation()">info</span>
                            <mat-error>Campo obrigatório</mat-error>
                        </mat-form-field>
                        }
                        @else if(isMensal){
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Dia do envio dos dados</mat-label>
                            <mat-select formControlName="valorRecorrencia">
                                @for(dia of diasMes; track dia){
                                <mat-option [value]="dia">{{dia}}</mat-option>
                                }
                            </mat-select>
                            <span matSuffix class="material-symbols-outlined info-icon"
                                matTooltip="Selecione o dia do mês que você quer receber os dados do fechamento do mês anterior"
                                (click)="$event.stopPropagation()">info
                            </span>
                            <mat-error>Campo obrigatório</mat-error>
                        </mat-form-field>
                        }
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6 toggle-container">
                        <mat-slide-toggle class="app-toggle-compact" formControlName="ativo">
                            {{ model.get('ativo')?.value ? 'Ativo' : 'Inativo' }}
                        </mat-slide-toggle>
                        <span class="material-symbols-outlined info-icon"
                            matTooltip="Se inativo, a automação não será executada.">info</span>
                    </div>
                </div>
            </div>

            <div class="action-card ">
                <h3 class="section-title">
                    <mat-icon>dataset</mat-icon> Configuração de Dados
                </h3>

                <div class="row">
                    <div class="col-md-6">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Funcionalidade / Tipo de Extração</mat-label>
                            <mat-select formControlName="idTipoExtracao">
                                @for(tipo of listaTiposExtracao; track tipo.idTipoExtracao){
                                <mat-option [value]="tipo.idTipoExtracao">{{tipo.tipoExtracao}}</mat-option>
                                }
                            </mat-select>
                            <mat-error>Selecione a funcionalidade</mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="dynamic-filters-area">
                    <h3 class="subsection-title">Filtros Específicos {{nomeTipoExtracao ? 'para ' + nomeTipoExtracao :
                        ''}}
                    </h3>

                    @if(isFiltroContador) {
                    <app-filtro-painel-contador [jsonFiltros]="jsonFiltrosEdicao"
                        [isEdicao]=this.isEdicao></app-filtro-painel-contador>
                    }
                    @else if (isFiltroNotaRecebida) {
                    <app-filtro-painel-nota-recebida [jsonFiltros]="jsonFiltrosEdicao"
                        [isEdicao]=this.isEdicao></app-filtro-painel-nota-recebida>
                    }
                    @else {
                    <p class="text-center p-3">
                        Selecione uma funcionalidade acima para visualizar os filtros disponíveis.
                    </p>
                    }
                </div>
            </div>

            @if(isEdicao){
            <div class="action-card  history-section">
                <h3 class="section-title">
                    <mat-icon>history</mat-icon> Histórico de Envio de Arquivos
                </h3>
                <app-alert-card type="info" [icon]="'timer'">
                    <span>
                        <strong>Nota Importante:</strong> Por questões de segurança, os links de download dos arquivos
                        gerados ficam ativos por apenas
                        <strong>7 dias</strong> após a data de envio.
                    </span>
                </app-alert-card>
                @if(dataSourceHistorico.data.length > 0){
                <table mat-table [dataSource]="dataSourceHistorico" class="w-100">

                    <ng-container matColumnDef="idAutomacaoExtracaoDadosHistorico">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element">
                            #{{element.automacaoExtracaoDadosHistorico.idAutomacaoExtracaoDadosHistorico}} </td>
                    </ng-container>

                    <ng-container matColumnDef="datetimeProcessamento">
                        <th mat-header-cell *matHeaderCellDef> Data </th>
                        <td mat-cell *matCellDef="let element">
                            {{element.automacaoExtracaoDadosHistorico.datetimeProcessamento | date:'dd/MM/yyyy HH:mm'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef> Status </th>
                        <td mat-cell *matCellDef="let element">
                            <span class="status-tag" [class.status-tag-erro]="isProcessadoComErro(element)"
                                [matTooltip]="getTooltipStatus(element)"
                                [matTooltipDisabled]="!isProcessadoComErro(element)">
                                <app-ui-tag [text]="element.statusExtracao" [icon]="getIconStatus(element)"
                                    [colorClass]="getColorClassStatus(element)"></app-ui-tag>
                            </span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="action-download">
                        <th class="arquivo_column" mat-header-cell *matHeaderCellDef> Arquivo </th>
                        <td mat-cell *matCellDef="let element">
                            <span [matTooltip]="getTooltipDownload(element)">
                                <button mat-mini-fab class="fab-action default" (click)="baixarArquivo(element)"
                                    [disabled]="!element.automacaoExtracaoDadosHistorico.urlArquivo || element.isLinkExpired">
                                    @if(element.isLinkExpired){
                                    <span class="material-symbols-outlined">file_download_off</span>
                                    } @else {
                                    <span class="material-symbols-outlined">download</span>
                                    }
                                </button>
                            </span>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumnsHistorico"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsHistorico;"></tr>
                </table>
                } @else {
                <div class="empty-history text-center p-4">
                    <app-empty-list [title]="'Nenhum dado foi gerado por esta automação ainda.'"></app-empty-list>
                </div>
                }
            </div>
            }
        </form>

    </div>
</div>
<app-footer-action [isLoadingSalvar]="isLoading" (cancelar)="cancelar()" (salvar)="salvar()"></app-footer-action>

@if(isLoading){
<div>
    <app-loading-box [height]="'100%'" [width]="'100%'"></app-loading-box>
</div>
}
